import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChoosePinView from "./view";
import { useSingleFlag } from "@/hooks/useFlags";
import { ReducersTypes } from "@/redux/reducers/Models";

export default function ChoosePin() {
  const navigate = useNavigate();
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);
  const user = useSelector((state: ReducersTypes) => state.userReducer);
  
  const isAvulsoFlow = !customer?.register?.document && user?.plate && (user?.name || user?.email || user?.phone);
  
  const { isEnabled: showSms, isLoading: isLoadingSms } = useSingleFlag('PD_PIN_SMS');
  const { isEnabled: showWhatsAppFlag, isLoading: isLoadingWhatsApp } = useSingleFlag('PD_PIN_WHATSAPP');
  const { isEnabled: showEmail, isLoading: isLoadingEmail } = useSingleFlag('PD_PIN_EMAIL');

  const showWhatsApp = Boolean(showWhatsAppFlag && isAvulsoFlow);

  const isLoadingFlags = isLoadingSms || isLoadingWhatsApp || isLoadingEmail;

  const goBack = () => navigate(-1);

  const goToPin = (type: "email" | "phone" | "whatsapp") => {
    navigate('/register/pin/' + type);
  }

  return (
    <ChoosePinView 
      goBack={goBack}
      goToPin={goToPin}
      showSms={showSms}
      showWhatsApp={showWhatsApp}
      showEmail={showEmail}
      isLoadingFlags={isLoadingFlags}
    />
  );
}
